import { CustomersDto } from '@/src/models/CustomersDto';
import { ChallengeDto } from '@/src/models/ChallengeDto';
import { Media } from '@/src/models/MeidaDto';

export class ChallengeParticipantDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  rejectedAt: string;
  credit: number;
  isSuccess: boolean;
  customer: CustomersDto;
  challenge: ChallengeDto;
  challengeImage?: Media;
}
